import { setVersion } from './setVersion';
export { setVersion };
setVersion('@uifabric/set-version', '6.0.0');
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/set-version/lib/index.js
// module id = 44
// module chunks = 0